import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url_img, site_url, invoice_img ,truck} from "./../config.js";
import axios from 'axios';
import { Link } from 'react-router-dom';
import { IndianCurrencyFormatter,FormatDate } from '../Function';
import { useLocation } from 'react-router-dom';
import './style.css';

function Index() {
  const { user } = useContext(AuthContext);
  const [data, setdata] = useState([]);
  const queryParams = new URLSearchParams(useLocation().search);
  const id = queryParams.get('id');



  const shopdetails = async () => {
    try {
        const response = await axios.get(site_url + '/bill_details/' +id);
        console.log(response.data);
        if (response.data.status == 'success') {
          // console.log(response.data.data);
            setdata(response.data.order);
        }
    } catch (error) {

    }
}

useEffect(() => {
  shopdetails();
},[id])

const getGrandTotal = () =>
data.reduce((total, item) => total + parseFloat(item.prosubtotal), 0);



  return (

    <div id="appCapsule">
    <div className="section mt-4">
              <div className="section-heading">
                <h2 className="title">Bill : #{id}</h2>
              
                
              </div>
              <div className="transactions">
                {/* item */}
              
                <table className="border-collapse border border-gray-300 table ">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Product</th>
                <th className="border p-2">Price</th>
                <th className="border p-2">Qty</th>
                <th className="border p-2">Subtotal</th>
                
              </tr>
            </thead>
            <tbody>
                {data?.map((item) => (
    
                
              <tr>
                <td><img src={item.proprice == '' ? truck: site_url_img+'/'+item.product_image} style={{width:'30px'}}/>
                <br></br>
                { item.proname}</td>
                <td><IndianCurrencyFormatter amount={item.proprice} /></td>
                <td>{ item.proqty}</td>
                <td><IndianCurrencyFormatter amount={item.prosubtotal} /></td>
                
              </tr>
              
                   ))}
              
              </tbody>
          </table>
          <h3 className="mt-3 text-lg font-bold text-center">
            Total Product : {(data.length > 0 && data.length)}
          </h3>
          <h3 className="mt-3 text-lg font-bold text-center">
            Grand Total: <IndianCurrencyFormatter amount={getGrandTotal()} /> 
          </h3>
          <center>
            <Link to={`/Editbill?id=${id}`}>
            <button className='btn btn-danger'>Edit Bill</button>
            </Link>
          </center>
              </div>
            </div>
    

      <Footer />
      <Sidebar />
      
      


    </div>
  )
}

export default Index